import React from 'react';
import ReactDOM from 'react-dom';
// import './index.css';
import { App } from './component/App';


jQuery(function ($) {
  $(".form-signin form").validate({
      errorContainer: "#errorContainer",
      errorLabelContainer: "#errorContainer ul",
      wrapper: "li",
      errorClass: "is-invalid",
      validClass: "is-valid",
      submitHandler: function (form) {
          $(form).find("button").attr("disabled");
          form.submit();
      }
  });

/*   $(".card-course .btn").on("click keyup", ( ev )=> {
      
    }); */

    let courseListEl = $('#course-list');
    if ( courseListEl.length > 0 ) {
      ReactDOM.render(
        <React.StrictMode>
          <App {...courseListEl.data()}/>
        </React.StrictMode>,
        courseListEl[0]
      );
    }

    
});

